import React from "react";
import { useSelector } from "react-redux";
import { Chip, Stack, Tooltip } from "@mui/material";
import InputIcon from "@mui/icons-material/Input";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import {
  selectGameStatusObject,
  selectFinalRevealState,
} from "features/gamestate/gameStateSlice";

const GameStateChip = () => {
  const gameState = useSelector(selectGameStatusObject);
  const finalReveal = useSelector(selectFinalRevealState);

  let icon = <InputIcon fontSize="small" />;
  let label = gameState.currentState;

  const pregenStatus = finalReveal?.pregenStatus;
  const showPregenBadge = pregenStatus && pregenStatus !== 'OK' && pregenStatus !== 'SKIPPED';
  const pregenColor = pregenStatus === 'FAILED' ? 'error' : 'warning';
  const pregenTooltip = `Pre-gen ${pregenStatus}: ${finalReveal?.pregenError || finalReveal?.pregenSummary || 'use the Advance button to skip stuck narrations'}`;

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Chip icon={icon} label={label} variant="outlined" color="primary" />
      {showPregenBadge && (
        <Tooltip title={pregenTooltip}>
          <Chip
            icon={<WarningAmberIcon fontSize="small" />}
            label={`pregen: ${pregenStatus.toLowerCase()}`}
            size="small"
            color={pregenColor}
            variant="outlined"
          />
        </Tooltip>
      )}
    </Stack>
  );
};

export default GameStateChip;
